import { IntersectionFade } from "../components/IntersectionFade";

export function CtaBand() {
  return (
    <section className="cta-band section-sm" id="cta" aria-labelledby="cta-heading">
      <div className="cta-band-content">
        <IntersectionFade>
          <span className="eyebrow">Ready to ship?</span>
          <h2 className="h2 mb-16" id="cta-heading">
            Deploy your first screen{" "}
            <span className="grad-text">in minutes</span>
          </h2>
          <p>
            Self-host on your own Cloudflare + Neon stack, or let us run it.
            Either way — unlimited screens, no lock-in, and proof-of-play from day one.
          </p>
          <div className="cta-band-btns">
            <a href="#pricing" className="btn btn-primary btn-lg">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <polyline points="13 17 18 12 13 7" />
                <polyline points="6 17 11 12 6 7" />
              </svg>
              Get started free
            </a>
            <a href="#pricing" className="btn btn-ghost btn-lg">
              Book a demo
            </a>
          </div>
        </IntersectionFade>
      </div>
    </section>
  );
}
